module.exports = __webpack_public_path__ + "img/plus2.62cdccd4.svg";